"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.time_zone_offset = exports.session = exports.CENTURY = exports.DECADE = exports.MONTH = exports.YEAR = exports.WEEK = exports.DAY = exports.HOUR = exports.MINUTE = exports.SECOND = exports.MILLISECOND = void 0;
exports.MILLISECOND = 1;
exports.SECOND = exports.MILLISECOND * 1000;
exports.MINUTE = exports.SECOND * 60;
exports.HOUR = exports.MINUTE * 60;
exports.DAY = exports.HOUR * 24;
exports.WEEK = exports.DAY * 7;
/* in average, not exact */
exports.YEAR = 365.2425 * exports.DAY;
exports.MONTH = exports.YEAR / 12;
exports.DECADE = exports.YEAR * 10;
exports.CENTURY = exports.YEAR * 100;
var session;
(function (session) {
    const intervals = {};
    function now(interval = 1000) {
        const now = Date.now();
        const last = intervals[interval];
        if (last) {
            if (now - last < interval) {
                return last;
            }
            else {
                intervals[interval] = now;
                return now;
            }
        }
        else {
            intervals[interval] = now;
            return now;
        }
    }
    session.now = now;
})(session || (exports.session = session = {}));
exports.time_zone_offset = new Date().getTimezoneOffset() * exports.MINUTE;
